export interface NorwayTargetPolygonSeed {
  name: string;
  label: string;
  note: string;
  description: string;
  color: string;
  opacity: number;
  coordinates: number[][];
}

export const NORWAY_TARGET_POLYGON_SEEDS: NorwayTargetPolygonSeed[] = [
  {
    name: 'Lomunda / Løkken',
    label: 'Lomunda / Løkken',
    note: 'Dragset-Løkken-Høydal-Åmot corridor',
    description:
      'Initial brownfield corridor polygon built from active Teako permits Løkken 4, 8, 9, and 12 covering Dragset, Løkken, Høydal, and Åmot.',
    color: '#f97316',
    opacity: 0.22,
    coordinates: [
      [9.883336, 63.094279],
      [9.877362, 63.087991],
      [9.863315, 63.085455],
      [9.501889, 63.096489],
      [9.492049, 63.099373],
      [9.487552, 63.104271],
      [9.489149, 63.152630],
      [9.495602, 63.156916],
      [9.506240, 63.158860],
      [9.746351, 63.157844],
      [9.870339, 63.147854],
      [9.880154, 63.144951],
      [9.884596, 63.140046],
    ],
  },
  {
    name: 'Grimsdalen',
    label: 'Grimsdalen',
    note: 'Folldal-Geitryggen-Sivilvangen core',
    description:
      'Initial brownfield core polygon built from Grimsdalen 6, 7, 14, and Sivilvangen 1 to capture the Folldal, Geitryggen, and Sivilvangen drill/core corridor.',
    color: '#06b6d4',
    opacity: 0.2,
    coordinates: [
      [10.159620, 62.109768],
      [10.051385, 62.109862],
      [9.950792, 62.129429],
      [9.943657, 62.132495],
      [9.940498, 62.136777],
      [9.943370, 62.159891],
      [9.954782, 62.164303],
      [10.515908, 62.247278],
      [10.618332, 62.246302],
      [10.632480, 62.242209],
      [10.635711, 62.237165],
      [10.634595, 62.218065],
      [10.625108, 62.211307],
    ],
  },
  {
    name: 'Hattfjellet',
    label: 'Hattfjellet',
    note: 'Raudvatnet-Sørtjørna-Famvatnet drill corridor',
    description:
      'Initial drill-backed corridor polygon built from Hattfjellet 14, 20, 21, and Kvittinden 5 covering Sørtjørna, Raudvatnet, Svarthammaren, and Famvatnet.',
    color: '#a855f7',
    opacity: 0.2,
    coordinates: [
      [14.322152, 65.637444],
      [14.198847, 65.656851],
      [14.190413, 65.663095],
      [14.190032, 65.683584],
      [14.291242, 65.842608],
      [14.307848, 65.846900],
      [14.423906, 65.847253],
      [14.436875, 65.844185],
      [14.442243, 65.838461],
      [14.452653, 65.645428],
      [14.446617, 65.640664],
      [14.433009, 65.637943],
    ],
  },
];

export const NORWAY_TARGET_LAYER_ORDER = NORWAY_TARGET_POLYGON_SEEDS.map((seed) => ({
  name: seed.name,
  label: seed.label,
  note: seed.note,
  color: seed.color,
}));
